import axios from 'axios';

export const authMixin = {
    methods: {
        getAuthenticatedUser() {
            const token = localStorage.getItem('authToken');
            if (token) {
                return axios.get('/api/user_detail/')
                .then(response => {
                     // console.log("Usuario autenticado-->:", response.data);
                    return response.data;
                })
                .catch(error => {
                    console.error("Error fetching user data:", error);
                    return null;
                });
            } else {
                console.error("No auth token found");
                return null;
            }
        }
    }
};